import { render, staticRenderFns } from "./NotificacionBalanceForm.vue?vue&type=template&id=bdce4658"
import script from "./NotificacionBalanceForm.vue?vue&type=script&lang=ts"
export * from "./NotificacionBalanceForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports